import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import usersReducer from './slices/usersSlice';
import adminReducer from './slices/adminSlice';
import modalSlice from "./slices/modalSlice"

const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer, // Add the users reducer
    admin: adminReducer, // Add the admin reducer
    modals: modalSlice,
  },
});

export default store;
